export const categories = [
  {
    id: "topics",
    name: "吃瓜话题",
    icon: "ri-chat-smile-2-line",
    desc: "从日常路透到节目成片，最容易聊起来的热门议题都在这。",
    count: 128,
  },
  {
    id: "events",
    name: "热点事件",
    icon: "ri-flashlight-line",
    desc: "突然刷屏的热点，第一时间梳理来龙去脉与各方说法。",
    count: 86,
  },
  {
    id: "circle",
    name: "圈内动态",
    icon: "ri-radar-line",
    desc: "节目排播、阵容官宣、幕后花絮，动态更新不间断。",
    count: 74,
  },
  {
    id: "opinion",
    name: "瓜友观点",
    icon: "ri-quill-pen-line",
    desc: "不站队、不跟风，把观点摆上桌，理性碰撞更有意思。",
    count: 52,
  },
];

export const siteInfo = {
  name: "黑料专区",
  slogan: "吃瓜讨论社区",
  tagline: "热门吃瓜话题与瓜友热议交流",
  intro:
    "黑料专区是一个聚焦吃瓜讨论与热门话题的社区。我们把每天刷屏的娱乐话题整理成结构清晰的话题页，让你不必翻遍评论区，也能快速看清大家在聊什么、怎么聊的。",
  email: "hello@heiliaozhuanqu.example.com",
  updateNote: "工作日内 24 小时回复",
  stats: [
    { label: "在架话题", value: "340+" },
    { label: "瓜友讨论", value: "12.6万" },
    { label: "每日更新", value: "20 条" },
    { label: "话题分类", value: "4 大类" },
  ],
  principles: [
    {
      icon: "ri-shield-check-line",
      title: "只聊公开信息",
      desc: "围绕已经公开的节目、作品与官方动态展开讨论，不做无依据的猜测。",
    },
    {
      icon: "ri-scales-3-line",
      title: "观点可以对立",
      desc: "鼓励不同角度并存，评论按话题聚合，让分歧被看见而不是被淹没。",
    },
    {
      icon: "ri-emotion-happy-line",
      title: "围观也要有礼貌",
      desc: "对事不对人，拒绝攻击性表达，让讨论氛围轻松一点。",
    },
    {
      icon: "ri-refresh-line",
      title: "持续整理更新",
      desc: "话题有后续就补充后续，尽量让每个话题页保持完整的时间线。",
    },
  ],
  testimonials: [
    {
      name: "阿柚",
      role: "追综 5 年",
      quote: "以前追一个综艺要翻好几个平台，现在在话题页里就能看到大家争什么，省事多了。",
    },
    {
      name: "小满",
      role: "评论区常驻",
      quote: "最喜欢它的评论分区，正反两派都能看到，比单看一边有意思。",
    },
    {
      name: "老白",
      role: "路人瓜友",
      quote: "分类很清爽，想看动态就看动态，想看观点就看观点，不会一锅炖。",
    },
  ],
};